<template>
  <div class="c-page-linkedin">
    <Page :i="4">
      <span class="c-byline"> Tutorial #3: Linkedin Ad Library </span>
      <h1>Save Ads from the Linkedin Ad Library</h1>
      <article class="article-text text-center">
        <p>Click on the blue "Save" button under any Ad to save it.</p>
        <p>This Ad will be available forever inside your Swipekit account, even if the original Ad is removed.</p>
      </article>
      <div class="c-showcase">
        <img src="/images/onboarding-linkedin.png" />
      </div>
      <ButtonCta :timer="3" @onClick="onClick">
        <span> Gotcha </span>
      </ButtonCta>
    </Page>
  </div>
</template>

<script>
import Page from "./page";
import ButtonCta from "./button-cta.vue";
export default {
  components: {
    Page,
    ButtonCta,
  },

  methods: {
    onClick: function () {
      this.$emit("onNext");
    },
  },
};
</script>

<style lang="scss"></style>
